/**
 * Olux+ — mostra il dettaglio di un contenuto nella stessa pagina
 * quando l'utente clicca "View Recipe" / "Start" / ecc., senza
 * ricaricare né lasciare il sito. Tutto gestito con show/hide diretto
 * via JS puro — nessun uso di URL hash o cronologia del browser,
 * per evitare comportamenti diversi tra browser/temi.
 * Nessun salvataggio, nessun tracker.
 *
 * NOTA: i pannelli .olux-detail vengono spostati come figli diretti
 * di <body>. Alcuni temi applicano un transform a un contenitore che
 * avvolge tutta la pagina (es. per smooth-scroll): quando un antenato
 * ha un transform, "position: fixed" smette di essere relativo alla
 * finestra e si comporta come "absolute" dentro quel contenitore.
 * Spostando il pannello direttamente in <body> evitiamo il problema
 * a prescindere da cosa fa il tema.
 */
(function () {
  function showDetail(handle) {
    document.querySelectorAll('[data-olux-grid]').forEach(function (grid) {
      grid.hidden = true;
    });
    document.querySelectorAll('[data-olux-detail]').forEach(function (detail) {
      detail.hidden = detail.getAttribute('data-olux-detail') !== handle;
    });
  }

  function showGrid() {
    document.querySelectorAll('[data-olux-detail]').forEach(function (detail) {
      detail.hidden = true;
    });
    document.querySelectorAll('[data-olux-grid]').forEach(function (grid) {
      grid.hidden = false;
    });
  }

  function moveDetailsToBody() {
    document.querySelectorAll('[data-olux-detail]').forEach(function (detail) {
      if (detail.parentElement !== document.body) {
        document.body.appendChild(detail);
      }
    });
  }

  document.addEventListener('click', function (e) {
    var openLink = e.target.closest('[data-olux-open]');
    if (openLink) {
      e.preventDefault();
      showDetail(openLink.getAttribute('data-olux-open'));
      return;
    }

    var backBtn = e.target.closest('[data-olux-back]');
    if (backBtn) {
      e.preventDefault();
      showGrid();
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    moveDetailsToBody();
    showGrid();
  });
})();